// see https://github.com/jaredLunde/react-hook/issues/314#issuecomment-2374479025

// oxlint-disable-next-line no-restricted-imports
import useRO from "@react-hook/resize-observer";

// oxlint-disable-next-line no-restricted-imports
import type { UseResizeObserverCallback } from "@react-hook/resize-observer";

class ServerSideResizeObserverPolyfill {
  constructor(_callback: ResizeObserverCallback) {}
  observe(_target: Element, _options?: ResizeObserverOptions) {}
  unobserve(_target: Element) {}
}

export function useResizeObserver<T extends Element>(
  target: React.RefObject<T> | React.ForwardedRef<T> | T | null,
  callback: UseResizeObserverCallback,
) {
  return useRO(target, callback, {
    polyfill: typeof window === "undefined" ? ServerSideResizeObserverPolyfill : null,
  });
}
